import directives from './module';
import {AnimatronProjectsFactory, AnimatronProjects} from '../services/AnimatronProjectsSvc';
import {SubscriptionSvc} from '../settings/services/SubscriptionSvc';

export class CreateVideoButton implements ng.IComponentController {
    isUpgradeDialog: boolean;
    className: string;
    private details     = options.user.subscriptionDetails.wave;
    private videosLimit = this.details.features.rolez.PrivateUnlistedProjects.numProjects;
    private videosCount: number;

    constructor(private $state: ng.ui.IStateService,
                private AnimatronProjects: AnimatronProjectsFactory) {
    }

    goUpgrade() {
        this.$state.go('wave-settings.subscription').then(() => this.isUpgradeDialog = false);
    }

    createNew() {
        this.setVideosCount().then(() => {
            if (this.canCreate) {
                window.open(`${options.waveEditorDomain}#new=1`, '_self');
            } else {
                this.isUpgradeDialog = true;
            }
        })
    }

    private setVideosCount() {
        const params: ProjectSearchCriteria = {
            product: 'WAVE',
            offset: 0,
            limit: 0
        };

        const animatronProjects = new AnimatronProjects(params, true);
        return animatronProjects.nextPage().then(() => this.videosCount = animatronProjects.count);
    }

    private get canCreate() {
        return this.details.name !== 'WaveFree' || this.videosCount < this.videosLimit;
    }
}

directives.component('createVideoButton', {
    bindings: {
        className: '@'
    },
    transclude: true,
    controller: CreateVideoButton,
    templateUrl: require('create-video-button.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/CreateVideoButton.ts